<evsb-accordion [closeOthers]="false" class="block">
  <evsb-panel [open]="true" (didOpen)="onPanelOpen('modify-quantity')">
    <div subheading>{{steps[0]}}/{{steps.length}} {{ 'modules.evsb.chargingStation.input.quantity.subtitle' | translate }}</div>
    <div heading>{{ 'modules.evsb.chargingStation.input.quantity.title' | translate }}</div>
    <main class="mb-12">
      <evsb-number-of-charging-stations [(amount)]="model.amount" (amountChange)="updateSolution()">
        <evsb-primary-button start-button (click)="wantsAtLeastOneChargingStation && goToNextStep(steps[0] - 1)" [fullWidth]="true"
          >{{ 'modules.evsb.chargingStation.input.start' | translate }}
        </evsb-primary-button>
      </evsb-number-of-charging-stations>
    </main>
  </evsb-panel>
  <evsb-panel [canOpen]="wantsAtLeastOneChargingStation" (didOpen)="onPanelOpen('chose-type')">
    <div subheading>{{steps[1]}}/{{steps.length}} {{ 'modules.evsb.chargingStation.input.type.subtitle' | translate }}</div>
    <div heading>{{ 'modules.evsb.chargingStation.input.type.title' | translate }}</div>
    <main class="mt-6">
      <evsb-choose-charging-speed
        [desiredChargingStations]="model.amount"
        [(choice)]="model.type"
        (choiceChange)="updateSolution()"
      ></evsb-choose-charging-speed>
      <evsb-primary-button
        (click)="hasChosenChargingSpeed && goToNextStep(steps[1] - 1)"
        [state]="stateForCurrentChoice"
        class="block mt-8"
      >
        {{ 'modules.evsb.chargingStation.input.next' | translate }}
      </evsb-primary-button>
    </main>
  </evsb-panel>
<!--  <evsb-panel [canOpen]="hasChosenChargingSpeed" (didOpen)="onPanelOpen('enable-smart-option')">-->
<!--    <div subheading>3/4 {{ 'modules.evsb.chargingStation.input.smartOption.subtitle' | translate }}</div>-->
<!--    <div heading>{{ 'modules.evsb.chargingStation.input.smartOption.title' | translate }}</div>-->
<!--    <main class="mt-6">-->
<!--      <evsb-smart-charging-station-->
<!--        [(optionActive)]="model.smart"-->
<!--        (optionActiveChange)="updateSolution()"-->
<!--      ></evsb-smart-charging-station>-->
<!--      <evsb-primary-button-->
<!--        (click)="wantsAtLeastOneChargingStation && hasChosenChargingSpeed && goToNextStep()"-->
<!--        class="block mt-8"-->
<!--        >{{ 'modules.evsb.chargingStation.input.next' | translate }}</evsb-primary-button-->
<!--      >-->
<!--    </main>-->
<!--  </evsb-panel>-->
  <evsb-panel
    [canOpen]="wantsAtLeastOneChargingStation && hasChosenChargingSpeed"
    (didOpen)="onPanelOpen('chose-place')"
  >
    <div subheading>{{steps[2]}}/{{steps.length}} {{ 'modules.evsb.chargingStation.input.location.subtitle' | translate }}</div>
    <div heading>{{ 'modules.evsb.chargingStation.input.location.title' | translate }}</div>
    <main class="mt-6">
      <evsb-charging-station-placement
        [desiredSpeed]="model.type"
        [(placement)]="model.location"
        (placementChange)="updateSolution()"
      ></evsb-charging-station-placement>
    </main>
  </evsb-panel>

</evsb-accordion>
